import type { Role } from '@/types';

/**
 * Returns a duplicate-name error message for a role that already exists.
 */
export function getDuplicateRoleError(existingRole: Pick<Role, 'name' | 'billingStructure'>): string {
  const label = existingRole.billingStructure === 'day_rate' ? 'a day rate' : 'an hourly';
  return `You already have ${existingRole.name} as ${label} role. Need different billing terms? Override per client or shift.`;
}
